import { DataBean } from "../../DataBean";


export class VehicleByAccount extends DataBean {

    public async getVehicleByAccount(idAccount: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getVehicleByAccount_Number", [idAccount]);
    }

}